var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_bg-default"},[(_vm.role == 4)?_c('ProfileStudent'):_vm._e(),(_vm.role == 3)?_c('ProfileMentor'):_vm._e(),(_vm.role == 2)?_c('ProfileTeacher'):_vm._e(),(_vm.role == 1)?_c('ProfileAdmin'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }